import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { Home, Gamepad2, Gift, Send, List } from "lucide-react";

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();
  const { user } = useAuth();
  
  const items = [
    { icon: Home, label: "home", path: "/dashboard" },
    { icon: Gamepad2, label: "games", path: "/games" },
    { icon: Gift, label: "refer", path: "/refer" },
    { icon: Send, label: "send", path: "/send" },
    { icon: List, label: "history", path: "/history" }
  ];

  if (!user || user.is_admin) return null;

  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      {items.map(item => (
        <button
          key={item.path}
          onClick={() => navigate(item.path)}
          className={`bottom-nav-item ${location.pathname === item.path ? "active" : ""}`}
          data-testid={`nav-${item.label}`}
        >
          <item.icon size={20} />
          <span>{t(item.label)}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;
